import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { BOTS_ORDER_BY, BOTS_SORT } from "../../actions/types";
import { Table, Collapse, Modal } from "react-bootstrap";
import { capitalize, currencyFormat, decimalOf, isLong, trimString } from "../../utils/Utils";
import { Link } from "react-router-dom";
import CustomSwitch from "./new-bot/modules/CustomSwitch";
import CustomCheckbox from "./new-bot/modules/CustomCheckbox";
import ToolTip from "../help/ToolTip";
import { BotTypeName, FrequenciesPro, FrequencyValuesPro, BotType } from "../../Const";
import { toast } from "react-toastify";
import BotReactivationModal from "./BotReactivationModal";
const BotTableView = (props) => {
    // ... (props distructuring remains same)
    const { bots, selectedIds, onSelect, onSelectAll, clickBotAction, activeBot, deleteBot, t, itemsPerPage, pageNum, selectedTab, selectedExchangeId, orderBy, sort, userId, clientStatusOrderBy, onStatusSort } = props;
    const [openMenuId, setOpenMenuId] = useState(null);
    const [expandedRowId, setExpandedRowId] = useState(null);
    const [reactivationData, setReactivationData] = useState(null);
    const [deleteConfirmBot, setDeleteConfirmBot] = useState(null);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const dispatch = useDispatch();

    const handleSort = (column) => {
        if (column === 'status') {
            onStatusSort();
            return;
        }
        if (sort === column) {
            dispatch({ type: BOTS_ORDER_BY, payload: orderBy === 'asc' ? 'desc' : 'asc' });
        } else {
            dispatch({ type: BOTS_SORT, payload: column });
            dispatch({ type: BOTS_ORDER_BY, payload: 'desc' });
        }
    };

    const getSortIcon = (column) => {
        if (column === 'status') {
            if (!clientStatusOrderBy) return <i className="fa-solid fa-sort ms-1 text-muted" style={{fontSize: '0.8em'}}></i>;
            return clientStatusOrderBy === 'asc'
                ? <i className="fa-solid fa-arrow-up ms-1" style={{fontSize: '0.8em'}}></i>
                : <i className="fa-solid fa-arrow-down ms-1" style={{fontSize: '0.8em'}}></i>;
        }
        if (sort !== column) return <i className="fa-solid fa-sort ms-1 text-muted" style={{fontSize: '0.8em'}}></i>;
        return orderBy === 'asc' ? <i className="fa-solid fa-arrow-up ms-1" style={{fontSize: '0.8em'}}></i> : <i className="fa-solid fa-arrow-down ms-1" style={{fontSize: '0.8em'}}></i>;
    };

    React.useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.open-table-content .dropdown')) {
                setOpenMenuId(null);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const isDollar = (strategy) => {
        return strategy && strategy.toLowerCase() != "short" ? selectedExchangeId == 1000 ? "₹" : "$" : "";
    };

    const submitStatusChange = (bot, nextStatus, reactivationAction = null) => {
        activeBot(bot.id, nextStatus, selectedExchangeId, itemsPerPage, pageNum, selectedTab, orderBy, sort, reactivationAction)
            .then((res) => {
                if (res.requires_reactivation_action) {
                    setReactivationData({
                        ...res,
                        bot,
                    });
                    return;
                }
                setReactivationData(null);
                if (res.message) {
                    toast.success(res.message);
                }
            })
            .catch((err) => {
                toast.error(err);
            });
    };

    const handleToggleStatus = (bot, checked) => {
        submitStatusChange(bot, checked ? "active" : "inactive");
    };

    const clickDelete = (bot) => {
        setOpenMenuId(null);
        setDeleteConfirmBot(bot);
    };

    const confirmDelete = () => {
        if (!deleteConfirmBot) {
            return;
        }

        setDeleteLoading(true);
        deleteBot(
            deleteConfirmBot.id,
            selectedExchangeId,
            itemsPerPage,
            pageNum,
            selectedTab,
            orderBy,
            sort
        )
            .then(() => {
                setDeleteConfirmBot(null);
                toast.success(t ? t("bot-deleted-msg") : "Bot deleted successfully");
            })
            .catch((err) => {
                toast.error(err);
            })
            .finally(() => {
                setDeleteLoading(false);
            });
    };

    const isAllSelected = bots.length > 0 && bots.every(b => selectedIds.includes(b.id));

    return (
        <div className="skltbs-panel mb-4">
            <div className="open-table-content otc">
                <table className="table align-middle">
                    <thead>
                        <tr>
                            <td className="" style={{ width: '60px' }}>
                                <div className="bot-table-view-checkbox" >
                                    <CustomCheckbox 
                                        id="select-all-bots" 
                                        checked={isAllSelected}
                                        callback={(checked) => onSelectAll(checked)}
                                    />
                                </div>
                            </td>
                            <td>#</td>
                            <td className="cursor-pointer" onClick={() => handleSort('name')} style={{userSelect: 'none'}}>Bot Name {getSortIcon('name')}</td>
                            <td>Bot Type</td>
                            <td className="cursor-pointer" onClick={() => handleSort('symbol')} style={{userSelect: 'none'}}>Symbol {getSortIcon('symbol')}</td>
                            <td>Used / Allocated</td>
                            <td className="cursor-pointer" onClick={() => handleSort('profit')} style={{userSelect: 'none'}}>Return {getSortIcon('profit')}</td>
                            <td className="cursor-pointer" onClick={() => handleSort('apy')} style={{userSelect: 'none'}}>APY {getSortIcon('apy')}</td>
                            <td className="cursor-pointer" onClick={() => handleSort('win_ratio')} style={{userSelect: 'none'}}>Win Rate {getSortIcon('win_ratio')}</td>
                            <td>Strategy</td>
                            <td style={{width:'100px',textAlign:'center'}}>Completed Trades</td>
                            <td className="cursor-pointer" onClick={() => handleSort('status')} style={{userSelect: 'none'}}>Status {getSortIcon('status')}</td>
                            <td>Action</td>
                        </tr>
                    </thead>
                    <tbody>
                        {bots.map((bot, index) => {
                            const pair = bot.exchange_pair.pair;
                            const baseCoin = pair.to;
                            const strategy = bot.strategy || "Long";
                            const currencySymbol = isDollar(strategy);
                            const isSelected = selectedIds.includes(bot.id);
                            const isActive = bot.status === 'active';
                            // Status Badge Logic
                            let statusBadgeClass = "bg-light text-secondary";
                            let statusText = capitalize(bot.status);
                            if (bot.statusVariant === 'active') {
                                statusBadgeClass = "trade-active-badge";
                                statusText = "Trade started";
                            } else if (bot.statusVariant === 'inactive') {
                                statusBadgeClass = "trade-inactive-badge";
                            } else if (bot.statusVariant === 'waiting' || bot.deal_status === 2) {
                                statusBadgeClass = "trade-monitoring-badge";
                                statusText = "Monitoring";
                            }
                           
                            // Strategy Badge Logic
                            const strategyBadgeClass = isLong(bot.strategy) ? "long" : "short";

                            return (
                                <React.Fragment key={bot.id}>
                                    <tr className={isSelected ? "bg-light" : ""} style={{ borderBottomColor: expandedRowId === bot.id ? 'transparent' : 'transparent' }}>
                                        <td className="" style={{width: '50px'}}>
                                        <div className="bot-table-view-checkbox">
                                            <CustomCheckbox 
                                                id={`bot-check-${bot.id}`}
                                                checked={isSelected}
                                                callback={() => onSelect(bot.id)}
                                            />
                                        </div>
                                    </td>
                                    <td className="text-dark fw-medium">{index + 1}</td>
                                    <td className="bot-data">
                                        <div className="d-flex align-items-center">
                                            <div className="text-truncate">
                                                <div className="text-truncate" title={bot.name}>
                                                    <Link to={`/bot-detail/${bot.id}`} className="text-dark text-decoration-none">
                                                        {trimString(bot.name, 20)}
                                                    </Link>
                                                </div>
                                                <div className="text-secondary small text-truncate">{bot.rent_id?<ToolTip content={bot.template_name}><a href="#" className="strategy_name">{bot.template_name && trimString(bot.template_name,14)}</a></ToolTip>:<></>}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="valume-data">
                                            <h6 className="mb-0">{bot.rent_id ? "Strategy" : (BotTypeName[bot.type] || "-")}</h6>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="pair-data">
                                            <div className="rounded-circle bg-white shadow-sm d-flex align-items-center justify-content-center me-2" style={{ width: '28px', height: '28px', padding: '4px' }}>
                                                <img 
                                                    src={pair.base_image} 
                                                    alt="" 
                                                    className="w-100 h-100"
                                                    style={{ objectFit: 'contain' }}
                                                />
                                            </div>
                                            <h6 className="symbol-name mb-0">{pair.from}/{pair.to}</h6>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="valume-data">
                                            <h6 className="mb-0">{currencySymbol}{currencyFormat(bot.allocated_fund, 0)} <span className="text-secondary fw-normal">/ {currencyFormat(bot.initial_fund, 0)}</span></h6>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="unr-return">
                                            <h6 className={`mb-0 ${parseFloat(bot.deals_analysis.total_performance) >= 0 ? "text-success" : "text-danger"}`}>
                                                {parseFloat(bot.deals_analysis.total_performance).toFixed(decimalOf(baseCoin))} {baseCoin}
                                            </h6>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="valume-data">
                                            <h6 className="mb-0">{bot.deals_analysis.apy}%</h6>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="valume-data">
                                            <h6 className="mb-0">{bot.deals_analysis.wl_ratio || 0}%</h6>
                                        </div>
                                    </td>
                                    <td className="dna-footer table-view">
                                        <a className={`${strategyBadgeClass} border-0`}>
                                            {strategy}
                                        </a>
                                    </td>
                                    <td className="valume-data text-center">
                                        <a className={`mb-0`}>
                                            {bot.deals_analysis.total_position}
                                        </a>
                                    </td>
                                    <td >
                                        <span className={`badge ${statusBadgeClass} border-0`} style={{ whiteSpace: 'nowrap' }}>
                                            {statusText}
                                        </span>
                                    </td>

                                    <td>
                                        <div className="d-flex align-items-center gap-2">
                                         {bot.type === BotType.advance && !bot.rent_id ? (
                                             <div 
                                                 className="cursor-pointer d-flex align-items-center justify-content-center bg-light rounded-circle" 
                                                 style={{ width: '28px', height: '28px', transition: 'all 0.3s' }}
                                                 onClick={(e) => {
                                                     e.stopPropagation();
                                                     setExpandedRowId(expandedRowId === bot.id ? null : bot.id);
                                                 }}
                                                 title={expandedRowId === bot.id ? "Collapse Row" : "Expand Row"}
                                             >
                                                 <i 
                                                     className="fa-solid fa-chevron-down text-secondary" 
                                                     style={{ 
                                                         transition: 'transform 0.3s', 
                                                         transform: expandedRowId === bot.id ? 'rotate(180deg)' : 'rotate(0deg)' 
                                                     }}
                                                 ></i>
                                             </div>
                                         ) : (
                                             <div style={{ width: '28px', height: '28px' }}></div>
                                         )}
                                         <ToolTip content={isActive ? "The bot is currently active. Click to deactivate it." : "The bot is currently inactive. Click to activate it."}>
                                             <div className="check-box">
                                                <CustomSwitch 
                                                    checked={isActive} 
                                                    onChange={(checked) => handleToggleStatus(bot, checked)}
                                                />
                                            </div>
                                        </ToolTip>
                                        <div className="dropdown" style={{position: 'relative',top: '-3px'}}>
                                            <i 
                                                className="fa-solid fa-ellipsis-vertical cursor-pointer p-2" 
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setOpenMenuId(openMenuId === bot.id ? null : bot.id);
                                                }}
                                            ></i>
                                            <ul className={`dropdown-menu ${openMenuId === bot.id ? "show" : ""} dna-cart-dropdown`} >
                                                <li>
                                                    <Link to={`/bot-detail/${bot.id}`} className="dropdown-item">
                                                        <img src="images/c-details-icon.png" alt="" className="me-2"/>
                                                        Details
                                                    </Link>
                                                </li>
                                                <li>
                                                    <a className="dropdown-item cursor-pointer" onClick={() => clickBotAction(bot.id, 'edit')}>
                                                        <img src="images/c-edit-icon.png" alt="" className="me-2"/>
                                                        Edit
                                                    </a>
                                                </li>
                                                <li>
                                                    <a className="dropdown-item cursor-pointer" onClick={() => clickBotAction(bot.id, 'copy')}>
                                                        <img src="images/c-copy-icon.png" alt="" className="me-2"/>
                                                        Copy
                                                    </a>
                                                </li>
                                                <li>
                                                    <a className="dropdown-item cursor-pointer" onClick={() => clickDelete(bot)}>
                                                        <img src="images/c-delete-icon.png" alt="" className="me-2"/>
                                                        Delete
                                                    </a>
                                                </li>
                                               
                                            </ul>
                                        </div>
                                        </div>
                                    </td>
                                </tr>
                                {bot.type != BotType.grid && bot.type != BotType.dca && !bot.rent_id && (
                                <tr className="bot-expanded-details">
                                    <td colSpan="12" className="p-0 border-0">
                                        <Collapse in={expandedRowId === bot.id}>
                                            <div>
                                                <div className={`p-4 ${isSelected ? "bg-light" : "bg-white"}`} style={{ borderTop: '1px dashed #e9ecef', borderBottom: '1px solid #dee2e6' }}>
                                                    <div className="row w-100 px-4">
                                                        <div className="col-md-3 col-sm-6 mb-3">
                                                            <span className="text-muted d-block small mb-1">Bot Type</span>
                                                            <strong className="text-dark fw-medium">{bot && BotTypeName[bot.type]}</strong>
                                                        </div>
                                                        <div className="col-md-3 col-sm-6 mb-3">
                                                            <span className="text-muted d-block small mb-1">Frequency</span>
                                                            <strong className="text-dark fw-medium">{bot && FrequenciesPro[FrequencyValuesPro.indexOf(bot.frequency)]}</strong>
                                                        </div>
                                                        <div className="col-md-3 col-sm-6 mb-3">
                                                            <span className="text-muted d-block small mb-1">Stoploss</span>
                                                            <strong className="text-dark fw-medium">{bot.stop_loss || 0} %</strong>
                                                        </div>
                                                        <div className="col-md-3 col-sm-6 mb-3">
                                                            <span className="text-muted d-block small mb-1">Take Profit</span>
                                                            <strong className="text-dark fw-medium">{bot.profit || 0} %</strong>
                                                        </div>
                                                        <div className="col-md-3 col-sm-6 mb-3">
                                                            <span className="text-muted d-block small mb-1">Order Type</span>
                                                            <strong className="text-dark fw-medium">{bot.order_type }</strong>
                                                        </div>
                                                        <div className="col-md-3 col-sm-6 mb-3">
                                                            <span className="text-muted d-block small mb-1">Minimum TP</span>
                                                            <strong className="text-dark fw-medium">{bot.min_tp }</strong>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Collapse>
                                    </td>
                                </tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                    </tbody>
                </table>
            </div>
            <BotReactivationModal
                show={!!reactivationData}
                onHide={() => setReactivationData(null)}
                onResume={() => submitStatusChange(reactivationData.bot, "active", "resume")}
                onRestart={() => submitStatusChange(reactivationData.bot, "active", "restart")}
                message={reactivationData?.message}
                symbol={reactivationData?.symbol}
                qty={reactivationData?.qty}
            />
            <ConfirmDialog
                show={!!deleteConfirmBot}
                onHide={() => setDeleteConfirmBot(null)}
                delete={confirmDelete}
                loading={deleteLoading}
            />
        </div>
    );
};

export default BotTableView;

const ConfirmDialog = (props) => {
    const clickCancel = () => props.onHide();
    return (
        <Modal show={props.show} onHide={props.onHide}>
            <Modal.Header>
                <Modal.Title>Confirm Dialog</Modal.Title>
            </Modal.Header>
            <Modal.Body>Please confirm that you would like to delete this bot by clicking the Delete button below.</Modal.Body>
            <Modal.Footer>
                <button className="red-button" onClick={props.delete} disabled={props.loading}>
                    {props.loading ? "Deleting..." : "Delete"}
                </button>
                <button className="grey-button" onClick={clickCancel} disabled={props.loading}>
                    Cancel
                </button>
            </Modal.Footer>
        </Modal>
    );
};
